import React, { useEffect, useState } from "react";
import moment from "moment";
import { Row, Col, Badge, Card, List } from "antd";
import styled from "styled-components";
import {
  Calendar as AntCalendar,
  Spin,
  Select,
  Checkbox,
  Modal,
  message,
} from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import {
  addMonthinDate,
  dateInDetail,
  getFirstDate,
  getKenyanDateTime,
  getLastDate,
  getMySqlDate,
  isDateBetweenTwoDates,
  momentDate,
} from "utils/Date";
import COLORS from "common/Colors";
import UpcomingHolidays from "organisms/UpcomingHolidays";
import StaffLeaveIndicatorInCalendar from "molecules/StaffLeaveIndicatorInCalendar";
import LeaveForm from "organisms/LeaveForm";
import { CALL_API } from "common/API";
import { connect } from "react-redux";
import {
  getAllDepartmentList,
  getUserRoleId,
  getSelectedDepartmentId,
  getUserInfo,
  getClientid,
  getMenuList,
  getLeaveCategoryList,
  getUserList,
  getRoleList,
} from "redux/selectors";
import {
  concat,
  debounce,
  filter,
  find,
  first,
  get,
  includes,
  map,
} from "lodash";
import { STATUS_CODE } from "common/Constants";
import LeaveList from "organisms/LeaveList";
import { DEVICE } from "common/Device";
import TabsList from "molecules/TabsList";
import { useTranslation } from "react-i18next";
import HomeIcon from "assets/wfhicon.svg";
import LeaveIcon from "assets/leaveicon.svg";
import OvertimeIcon from "assets/overtimeicon.svg";
import TimeoffIcon from "assets/timeoff.svg";
import CustomCalendar from "./CustomCalendar";
import dayjs from "dayjs";

const StyledTitle = styled.div`
  font-size: larger;
  font-weight: bold;
  padding: 10px 0px 20px 0px;
  @media (max-width: 320px) {
    font-size: small !important;
  }
`;

const StyledAntCalendarSmall = styled(AntCalendar)`
  background: #e2e2e8 !important;
  border-radius: 10px;
  .ant-picker-calendar-header {
    display: none;
  }
  .ant-picker-calendar {
    line-height: 1rem;
  }
  .ant-picker-body {
    width: 100%;
    padding-top: 0px !important;
  }
  .ant-picker-content {
    height: 200px;
    th {
      width: 30px;
      line-height: 40px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.45); /* muted gray for day labels */
      border-bottom: 1px solid #fff;
    }
    td {
      padding: 0px;
    }
    tr {
      height: 15px;
      line-height: 15px;
    }
    .ant-picker-calendar-date-content {
      display: none;
    }
  }
  .ant-picker-panel {
    background: transparent !important;
  }
  td,
  th {
    font-size: 0.8rem;
    width: 20px;
    color: rgba(0, 0, 0, 0.85); /* default date color */
  }
  .ant-picker-date-panel {
    width: 95%;
  }
  .ant-picker-cell::before {
    height: 20px;
  }

  /* out-of-month days */
  .ant-picker-cell:not(.ant-picker-cell-in-view)
    .ant-picker-calendar-date-value {
    color: rgba(0, 0, 0, 0.25);
  }
  .ant-picker-cell-selected .ant-picker-calendar-date {
    background: transparent !important;
  }
  .ant-picker-cell-selected .ant-picker-calendar-date-value {
    border: none !important;
  }
  .ant-picker-cell-selected .ant-picker-calendar-date {
    background: transparent !important;
    border: none !important;
  }

  .ant-picker-calendar-date-today {
    border: none !important;
  }

  .ant-picker-calendar-date-today::before {
    border: none !important;
  }

  .ant-picker-cell-today .ant-picker-calendar-date::before {
    border: none !important;
    display: none !important;
  }
  /* selected date — dark navy circle */
  .ant-picker-cell-selected .ant-picker-calendar-date-value {
    background: #1e2d47 !important;
    color: #fff !important;
    border-radius: 50%;
  }
`;

const StyledAntCalendarFull = styled(AntCalendar)`
  background: transparent !important;
  width: 100% important;
  .ant-picker-calendar-header {
    display: none;
  }
  .ant-picker-panel {
    background: transparent !important;
  }
  .ant-picker-cell,
  th {
    border: solid 1px #9c9c9c;
    text-align: left;
  }
  th {
    width: 100px;
    padding: 10px !important;
    text-align: center;
    font-weight: bold;
    border-bottom: none;
  }
  th:nth-child(1):after {
    content: "UN";
  }
  th:nth-child(2):after {
    content: "ON";
  }
  th:nth-child(3):after {
    content: "UE";
  }
  th:nth-child(4):after {
    content: "ED";
  }
  th:nth-child(5):after {
    content: "HU";
  }
  th:nth-child(6):after {
    content: "RI";
  }
  th:nth-child(7):after {
    content: "AT";
  }
  .ant-picker-cell-in-view {
    color: ${COLORS.BLACK};
  }
  tbody tr:nth-child(1) td {
    border-top: none !important;
  }

  @media ${DEVICE.mobileL} {
    th {
      font-size: 10px;
      font-weight: 500px;
      width: 100% !important;
      text-align: left;
      padding: 0 !important;
    }
  }
`;

const SmallCalendar = styled(Row)`
  padding: 10px 0px 10px 10px;
  background: #e2e2e8 !important;
  border-radius: 10px;
  margin-bottom: 3px;
`;

const smallCalendarIconStyle = {
  padding: "0px 10px",
  fontSize: "1rem",
  userSelect: "none",
};

const StyledPreviousIcon = styled(LeftOutlined)`
  ${smallCalendarIconStyle}
`;

const StyledNextIcon = styled(RightOutlined)`
  ${smallCalendarIconStyle}
`;

const StyledUpcomingHolidaysContainer = styled.div`
  padding: 20px 0px;
`;

const StyledLeaveCount = styled.div`
  height: 15px;
  width: 15px;
  margin: 10px;
  border-radius: 50%;
  ${({ color }) => color && `background: ${color}`};
`;

const StyledLeaveText = styled.div`
  padding: 5px;
`;

const StyledDateCell = styled.div`
  padding: 15px 5px 5px 5px;
  .day {
    padding: 6px 5px;
    border-radius: 50px;
    font-size: 0.8rem;
    font-weight: bold;
  }
  .has-pending-leaves {
    background: ${COLORS.PENDING_LEAVE};
    color: ${COLORS.WHITE};
  }
  .hr-leave-container {
    text-align: center;
    padding-top: 50px;

    .ant-badge-count {
      min-width: 30px !important;
      height: 30px !important;
      line-height: 30px !important;
      border-radius: 50px;
      font-size: 14px;
      box-shadow: 0px 1px 5px #6f6f6f;
      font-weight: bold;
    }
    @media (max-width: 935px) {
      .ant-badge-count {
        min-width: 15px !important;
        height: 15px !important;
        line-height: 15px !important;
      }
    }
    @media (max-width: 762px) {
      .ant-badge-count {
        min-width: 30px !important;
        height: 30px !important;
        line-height: 30px !important;
      }
    }
    @media (max-width: 600px) {
      .ant-badge-count {
        min-width: 15px !important;
        height: 15px !important;
        line-height: 15px !important;
      }
    }
    .hr-has-pending-leaves {
      margin-right: 2px;
      .ant-badge-count {
        background: ${COLORS.PENDING_LEAVE};
      }
    }
  }
  .hr-has-approved-leaves {
    margin-left: 3px;
    .ant-badge-count {
      background: ${COLORS.APPROVED_LEAVE};
    }
  }
  @media ${DEVICE.mobileL} {
    padding: 0px;
    height: 100px;
    .hr-leave-container {
      padding-top: 0px;
    }
  }
  .has-approved-leaves {
    background: ${COLORS.APPROVED_LEAVE};
    color: ${COLORS.WHITE};
  }
  .ant-picker-calendar-date-content {
    height: 46px;
    margin-top: 5px;
  }
`;

const StyleDepartmentDropdown = styled(Select)`
  width: 200px;
  text-align: left;
  @media ${DEVICE.tablet} {
    width: 100% !important;
    margin-bottom: 10px;
  }
`;

const StyledHolidayBadge = styled(Badge)`
  margin-top: 5px;
  background: red;
  padding: 5px;
  color: white;
  border-radius: 50%;
  font-size: 9px;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -2px;
  left: 14px;
`;
const StyledBadge = styled(Badge)`
  padding: 5px;
  color: white;
  border-radius: 50%;
  font-size: 9px;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledCheckbox = styled(Checkbox)`
  padding: 5px;
  padding-left: 10px;
  padding-top: 10px;
`;

const StyledLeftPanel = styled(Col)`
  @media ${DEVICE.mobileS} {
    padding-bottom: 20px;
  }
`;

function Calendar({
  userRoleId,
  selectedDepartmentId,
  allDepartmentList,
  userInfo,
  ClientId,
  leaveCategoryList,
  menuList,
  userList,
  roleList,
}) {
  const { i18n, t } = useTranslation();

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  let tabMenus = Menulist.filter(
    (item) =>
      item.key === "mycalendar" ||
      item.key === "teamcalendar" ||
      item.key === "allcalendar"
  );

  let newArray = [];
  newArray.push(...tabMenus);

  const items =
    newArray &&
    newArray
      ?.filter((data) => data.access === true)
      .map((data, index) => ({
        id: index,
        label: t(data.subtitle),
        component: <></>,
      }));

  const [miniCalendarCurrentDate, setMiniCalendarCurrentDate] = useState(
    getKenyanDateTime()
  );
  const [departmentSelectedByHR, setDepartmentSelectedByHR] = useState("");
  const [leaveListFiterForHR, setLeaveListFiterForHR] = useState({});
  const [leaveList, setLeaveList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [myTeamLeaveList, setMyTeamLeaveList] = useState([]);
  console.log("leaveList", leaveList);
  const [allLeaveList, setAllLeaveList] = useState([]);
  const [wfhList, setWfhList] = useState([]);
  const [timeoffList, setTimeoffList] = useState([]);
  const [overtimeList, setOvertimeList] = useState([]);

  const [displayLoader, toggleDisplayLoader] = useState(false);
  const [displayLeaveModal, toggleLeaveModal] = useState(false);
  const [editLeaveDisable, setEditLeaveDisable] = useState(false);
  const [isLeaveListModalVisible, toggleLeaveListModalVisible] =
    useState(false);
  const [leaveDetails, setLeaveDetails] = useState({});
  const [showMyTeamLeaves, toggleMyTeamLeave] = useState(false);
  const [tabId, setTabId] = useState(items ? items[0].label : "");
  const [allHolidayList, setAllHolidayList] = useState([]);

  moment.updateLocale("en", {
    weekdaysMin: ["S", "M", "T", "W", "T", "F", "S"],
  });

  const handleEditIconClick = () => {
    setEditLeaveDisable(true);
  };

  const handleTabSelect = (key) => {
    setLeaveList([]);
    setMyTeamLeaveList([]);
    const activeTab = items.find((item) => item.id === key);
    if (activeTab) {
      setTabId(activeTab.label);
    }
    if (key === 0) {
      toggleMyTeamLeave(!showMyTeamLeaves);
    }
  };

  useEffect(() => {
    debounceGetLeaveList();
    getData("wfhrequest");
    getData("permissionrequest");
    getData("overtimerequest");
  }, [tabId]);

  useEffect(() => {
    debounceGetLeaveList();
    getData("wfhrequest");
    getData("permissionrequest");
    getData("overtimerequest");
  }, [miniCalendarCurrentDate, showMyTeamLeaves]);

  useEffect(() => {
    debounceGetHolidayList();
  }, [miniCalendarCurrentDate]);

  useEffect(() => {
    setTabId(
      tabId === "All" || tabId === "Tous"
        ? t("All")
        : tabId === "My Team" || tabId === "Mon équipe"
        ? t("My Team")
        : t("Mine")
    );
  }, [i18n.language, items]);

  const getData = async (request) => {
    toggleDisplayLoader(true);
    let apiUrl = "";
    let responseData = [];

    try {
      // Build API URL based on active tab
      if (tabId === t("Mine")) {
        apiUrl = `employeerequest/${request}?tabStatus=${"calendarmine"}&userId=${
          userInfo?.userid
        }&statusId=${["0", "1"]}&startDate=${dayjs(
          getFirstDate(miniCalendarCurrentDate)
        ).format("YYYY-MM-DD")}&endDate=${dayjs(
          getLastDate(miniCalendarCurrentDate)
        ).format("YYYY-MM-DD")}`;
      } else if (tabId === t("My Team")) {
        apiUrl = `employeerequest/${request}?tabStatus=${"calendarmyteam"}&reportingManager=${
          userInfo?.userid
        }&statusId=${["0", "1"]}&startDate=${dayjs(
          getFirstDate(miniCalendarCurrentDate)
        ).format("YYYY-MM-DD")}&endDate=${dayjs(
          getLastDate(miniCalendarCurrentDate)
        ).format("YYYY-MM-DD")}`;
      } else if (tabId === t("All")) {
        apiUrl = `employeerequest/${request}?tabStatus=${"calendarhr"}&statusId=${[
          "0",
          "1",
        ]}&startDate=${dayjs(getFirstDate(miniCalendarCurrentDate)).format(
          "YYYY-MM-DD"
        )}&endDate=${dayjs(getLastDate(miniCalendarCurrentDate)).format(
          "YYYY-MM-DD"
        )}`;
      }

      const { code, data } = await CALL_API(apiUrl, "get");

      if (code === STATUS_CODE.SUCCESS) {
        responseData = data || [];

        // Store data in appropriate state based on tab
        if (request === "wfhrequest") {
          setWfhList(responseData);
        } else if (request === "permissionrequest") {
          setTimeoffList(responseData);
        } else if (request === "overtimerequest") {
          setOvertimeList(responseData);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      toggleDisplayLoader(false);
    }
  };

  const getLeaveList = async () => {
    setLeaveList([]);
    setMyTeamLeaveList([]);
    toggleDisplayLoader(true);
    const {
      code,
      leaves,
      teamLeaves = [],
    } = await CALL_API(`leave-list/${ClientId}`, "post", {
      status_id: "4,5",
      department_id: [""],
      selected_role_id: userRoleId,
      start_date: getFirstDate(miniCalendarCurrentDate),
      end_date: getLastDate(miniCalendarCurrentDate),
      show_my_team_leave: showMyTeamLeaves ? true : false,
    });
    toggleDisplayLoader(false);
    if (code === STATUS_CODE.SUCCESS) {
      setAllLeaveList(leaves);
      setLeaveList(
        leaves?.filter((val) => val?.userid === get(userInfo, "userid", ""))
      );
      setMyTeamLeaveList(
        leaves?.filter(
          (val) =>
            userInfo?.userid === val?.reporting_manager &&
            val?.userid !== get(userInfo, "userid", "")
        )
      );
    }
  };

  const getHolidayList = async () => {
    const filteruser = userList?.filter(
      (item) => item?.userid === userInfo.userid
    );
    const baselocationid = filteruser[0]?.baselocationid;
    const response = await CALL_API(`holiday-list/${ClientId}`, "post", {
      start_date: getFirstDate(miniCalendarCurrentDate),
      end_date: getLastDate(miniCalendarCurrentDate),
    });
    setHolidayList(
      response?.filter((item) => item?.location_id?.includes(baselocationid))
    );
    const filterrole = roleList?.filter((item) => item?.roleId === userRoleId);
    const filterlocationid = filterrole[0]?.locationId;
    setAllHolidayList(
      response.filter((item) =>
        item.location_id.some((id) => filterlocationid?.includes(id))
      )
    );
  };

  const debounceGetLeaveList = debounce(getLeaveList, 100);
  const debounceGetHolidayList = debounce(getHolidayList, 100);

  const previousMonth = () =>
    setMiniCalendarCurrentDate(
      momentDate(addMonthinDate(miniCalendarCurrentDate, "-1"))
    );

  const nextMonth = () =>
    setMiniCalendarCurrentDate(
      momentDate(addMonthinDate(miniCalendarCurrentDate, "1"))
    );

  const addLeave = (event, cellDate) => {
    if (userRoleId !== 1) {
      const isPastDate =
        moment(getMySqlDate(cellDate)) < moment(getMySqlDate("2022-08-01"));

      if (!isPastDate) {
        toggleLeaveModal(true);
        setLeaveDetails({
          start_date: cellDate,
          end_date: cellDate,
        });
      }
    }
  };

  const dateFullCellRender = (cellDate) => {
    const isCurrentMonth = true;
    const { date: day, day: Days } = dateInDetail(cellDate);
    const leave = filter(
      leaveList,
      ({ start_date, new_start_date, new_end_date, end_date, status_id }) =>
        includes(["4", "5"], status_id) &&
        isDateBetweenTwoDates(
          cellDate,
          new_start_date === "null" ||
            new_start_date === null ||
            new_start_date === ""
            ? start_date
            : new_start_date,
          new_end_date === "null" ||
            new_end_date === null ||
            new_end_date === ""
            ? end_date
            : new_end_date
        ),
      {}
    );

    const teamLeave =
      tabId === t("All") ||
      (tabId === t("My Team") &&
        filter(
          myTeamLeaveList,
          ({ start_date, new_start_date, new_end_date, end_date, status_id }) =>
            includes(["4", "5"], status_id) &&
            isDateBetweenTwoDates(
              cellDate,
              new_start_date === "null" ||
                new_start_date === "" ||
                new_start_date === null
                ? start_date
                : new_start_date,
              new_end_date === "null" ||
                new_end_date === "" ||
                new_end_date === null
                ? end_date
                : new_end_date
            ),
          {}
        ));

    const leaveDetails = first(tabId === t("Mine") ? leave : teamLeave);
    const filterleavetype = leaveCategoryList?.filter(
      (item) => item.leave_category_id === leaveDetails?.leave_category_id
    );
    const holidayrequired = filterleavetype[0]?.holiday;
    const weekendrequired = filterleavetype[0]?.weekend;
    const isSaturdayrequired = filterleavetype[0]?.isSaturday;
    const statusId = get(leaveDetails, "status_id", "");
    const havingcancelrequest = get(leaveDetails, "having_cancel_request", "");
    const isHoliday = find(
      tabId === t("Mine") ? holidayList : allHolidayList,
      ({ start_date, end_date }) =>
        isDateBetweenTwoDates(cellDate, start_date, end_date)
    );
    const leaveType =
      isCurrentMonth &&
      statusId === "4" &&
      (weekendrequired === "Yes" ? Days : Days !== "Sunday") &&
      (isSaturdayrequired === "Yes" ? Days : Days !== "Saturday") &&
      (holidayrequired === "Yes" || tabId === t("My Team") ? Days : !isHoliday)
        ? "has-pending-leaves"
        : havingcancelrequest === "1" &&
          (weekendrequired === "Yes" ? Days : Days !== "Sunday") &&
          (isSaturdayrequired === "Yes" ? Days : Days !== "Saturday") &&
          (holidayrequired === "Yes" || tabId === t("My Team")
            ? Days
            : !isHoliday)
        ? "has-pending-leaves"
        : statusId === "5" &&
          (weekendrequired === "Yes" ? Days : Days !== "Sunday") &&
          (isSaturdayrequired === "Yes" ? Days : Days !== "Saturday") &&
          (holidayrequired === "Yes" || tabId === t("My Team")
            ? Days
            : !isHoliday)
        ? "has-approved-leaves"
        : "";

    const leaveColor = get(isHoliday, "color", "");
    const hrPendingLeaves = filter(
      allLeaveList,
      ({
        start_date,
        end_date,
        status_id,
        having_cancel_request,
        new_start_date,
        new_end_date,
      }) =>
        (status_id === "4" &&
          isDateBetweenTwoDates(cellDate, start_date, end_date)) ||
        (status_id === "5" &&
          having_cancel_request === "1" &&
          isDateBetweenTwoDates(cellDate, new_start_date, new_end_date)),
      {}
    ).length;

    const hrApprovedLeaves = filter(
      allLeaveList,
      ({ start_date, end_date, status_id, having_cancel_request }) =>
        status_id === "5" &&
        (having_cancel_request === "0" || having_cancel_request === "") &&
        isDateBetweenTwoDates(cellDate, start_date, end_date),
      {}
    ).length;

    return (
      <>
        {tabId === t("Mine") && (
          <StyledDateCell
            onClick={(event) =>
              Menulist?.find(
                (item) => item?.key === "mycalendar" && item?.permission?.create
              )
                ? addLeave(event, cellDate)
                : ""
            }
          >
            <span className={`day `}>
              {isCurrentMonth && (
                <>
                  {leaveColor && (
                    <StyledHolidayBadge
                      status="success"
                      size="small"
                      color={leaveColor}
                    >
                      H
                    </StyledHolidayBadge>
                  )}
                  {leaveType &&
                    tabId === t("Mine") &&
                    map(leave, (leaveDetails) => (
                      <StaffLeaveIndicatorInCalendar
                        icon="team"
                        leaveDetails={leaveDetails}
                        isStaff={true}
                        day={day}
                        openEditLeaveModal={(details) => {
                          cancelLeaveRequest(details);
                        }}
                        EditLeaveModal={(details) => {
                          cancelLeave(details);
                        }}
                        handleEditIconClick={handleEditIconClick}
                      >
                        {day}
                      </StaffLeaveIndicatorInCalendar>
                    ))}
                  {!leaveType && day}
                </>
              )}
            </span>
            <div className="ant-picker-calendar-date-content"></div>
          </StyledDateCell>
        )}

        {tabId === t("My Team") && (
          <StyledDateCell>
            <b>{day}</b>
            {leaveColor && (
              <StyledHolidayBadge
                status="success"
                size="small"
                color={leaveColor}
              >
                H
              </StyledHolidayBadge>
            )}
            <div className="ant-picker-calendar-date-content">
              {leaveType &&
                tabId === t("My Team") &&
                map(teamLeave, (leaveDetails) => (
                  <StaffLeaveIndicatorInCalendar
                    key={leaveDetails.user_leave_id}
                    icon="team"
                    leaveDetails={leaveDetails}
                    isStaff={false}
                    reloadList={getLeaveList}
                    handleEditIconClick={handleEditIconClick}
                    openEditLeaveModal={() => {
                      setLeaveDetails(leaveDetails);
                      toggleLeaveModal(true);
                    }}
                    EditLeaveModal={() => {
                      setLeaveDetails(leaveDetails);
                      toggleLeaveModal(true);
                    }}
                    displayLeaveDetail={tabId === t("All") ? true : false}
                    Days={Days}
                  />
                ))}
            </div>
          </StyledDateCell>
        )}

        {tabId === t("All") && (
          <StyledDateCell>
            <b>{day}</b>
            {leaveColor && (
              <StyledHolidayBadge
                status="success"
                size="small"
                color={leaveColor}
              >
                H
              </StyledHolidayBadge>
            )}
            <div className="ant-picker-calendar-date-content">
              {tabId === t("All") && (
                <>
                  <div className="hr-leave-container">
                    <Badge
                      count={hrPendingLeaves}
                      className="hr-has-pending-leaves"
                      onClick={() => {
                        setLeaveListFiterForHR({
                          date: cellDate,
                          status_id: "4",
                        });
                        toggleLeaveListModalVisible(true);
                      }}
                    />
                    <Badge
                      count={hrApprovedLeaves}
                      className="hr-has-approved-leaves"
                      onClick={() => {
                        setLeaveListFiterForHR({
                          date: cellDate,
                          status_id: "5",
                        });
                        toggleLeaveListModalVisible(true);
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </StyledDateCell>
        )}
      </>
    );
  };

  const cancelLeaveRequest = (details) => {
    const {
      user_leave_id,
      start_date: leave_start_date,
      end_date: leave_end_date,
      status_id,
    } = details;
    if (userRoleId !== 1 && status_id !== "4") {
      Modal.confirm({
        icon: "",
        content: t("Are you sure you want to cancel your leave application?"),
        okText: t("YES"),
        cancelText: t("No"),
        onOk: () => {
          return new Promise(async (resolve) => {
            const payload = {
              userid: details?.userid,
              user_leave_id,
              status_id: "9",
              is_cancel_request: false,
              start_date: getMySqlDate(leave_start_date),
              end_date: getMySqlDate(leave_end_date),
            };
            const { code } = await CALL_API(
              `approve-reject-cancel-leave/${ClientId}`,
              "post",
              {
                userid: details?.userid,
                user_leave_id,
                status_id: "9",
                is_cancel_request: false,
                start_date: getMySqlDate(leave_start_date),
                end_date: getMySqlDate(leave_end_date),
              }
            );
            if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
              message.error(t("Oops!! something went wrong."));
            } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
              message.error(t("Invalid payload. Please enter correct data."));
            } else if (code === STATUS_CODE.RECORD_EXIST) {
              message.error(t("Leave already exist."));
            } else if (code === STATUS_CODE.SUCCESS) {
              message.success(t("Your leave application has been cancelled."));
              getLeaveList();
              // Call webhook API
            }
            resolve();
          }).catch((err) => console.log("[cancelLeaveRequest] Error -->", err));
        },
      });
    } else {
      setLeaveDetails(details);
      toggleLeaveModal(true);
    }
  };

  const cancelLeave = (details) => {
    const {
      user_leave_id,
      start_date: leave_start_date,
      end_date: leave_end_date,
      status_id,
    } = details;
    if (userRoleId !== 1 && status_id === "4") {
      Modal.confirm({
        icon: "",
        content: t("Are you sure you want to cancel your leave application?"),
        okText: t("YES"),
        cancelText: t("No"),
        onOk: () => {
          return new Promise(async (resolve) => {
            const { code } = await CALL_API(
              `approve-reject-cancel-leave/${ClientId}`,
              "post",
              {
                userid: details?.userid,
                user_leave_id,
                status_id: "9",
                is_cancel_request: false,
                start_date: getMySqlDate(leave_start_date),
                end_date: getMySqlDate(leave_end_date),
              }
            );
            if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
              message.error(t("Oops!! something went wrong."));
            } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
              message.error(t("Invalid payload. Please enter correct data."));
            } else if (code === STATUS_CODE.RECORD_EXIST) {
              message.error(t("Leave already exist."));
            } else if (code === STATUS_CODE.SUCCESS) {
              message.success(t("Your leave application has been cancelled."));
              getLeaveList();
              // Call webhook API
            }
            resolve();
          }).catch((err) => console.log("[cancelLeave] Error-->", err));
        },
      });
    } else {
      setLeaveDetails(details);
      toggleLeaveModal(true);
    }
  };

  const { year } = dateInDetail(miniCalendarCurrentDate);
  const localizedMonthName = t(
    moment(miniCalendarCurrentDate).locale(i18n.language).format("MMMM")
  );
  const iconStyle = { fontSize: "1.2rem" };

  const cardItems = [
    // { icon: HomeIcon, label: t("WFH") },
    {
      icon: TimeoffIcon,
      label: t("Time Off in Lieu"),
    },
    { icon: LeaveIcon, label: t("Leave") },
    // { icon: OvertimeIcon, label: t("Overtime") },
  ];

  return (
    <>
      <TabsList items={items} handleTabSelect={handleTabSelect} />
      <Row gutter={20}>
        <StyledLeftPanel xs={24} sm={15} md={10} lg={10} xl={6}>
          <StyledTitle>
            {tabId === t("Mine") && t("My ")}
            {t("Calendar")}
          </StyledTitle>
          <SmallCalendar>
            <Col span={14} className="font-bold">
              {localizedMonthName} {year}
            </Col>
            <Col span={10} className="align-right">
              <StyledPreviousIcon onClick={previousMonth} />
              <StyledNextIcon onClick={nextMonth} />
            </Col>
          </SmallCalendar>
          <StyledAntCalendarSmall
            fullscreen={false}
            value={momentDate(miniCalendarCurrentDate)}
          />

          <List
            grid={{ gutter: 0, column: 2 }}
            dataSource={cardItems}
            style={{
              borderBottom: "1px solid #ccc",
              marginTop: 20,
              // borderRadius: 8,
              overflow: "hidden",
            }}
            renderItem={({ icon, label }) => (
              <List.Item>
                <List.Item.Meta
                  title={
                    <span
                      style={{
                        fontSize: 12,
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      <img
                        src={icon}
                        alt={label}
                        style={{ width: 22, height: 22 }}
                      />
                      {label}
                    </span>
                  }
                />
              </List.Item>
            )}
          />

          <StyledUpcomingHolidaysContainer>
            <UpcomingHolidays holidayList={holidayList}></UpcomingHolidays>
          </StyledUpcomingHolidaysContainer>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "13px",
                color: "rgba(0,0,0,0.85)",
              }}
            >
              <span
                style={{
                  width: "15px",
                  height: "15px",
                  borderRadius: "50%",
                  background: "#fa8c16",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    background: "#fff",
                    display: "inline-block",
                  }}
                />
              </span>
              {t("Pending")}
            </span>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "13px",
                color: "rgba(0,0,0,0.85)",
              }}
            >
              <span
                style={{
                  width: "15px",
                  height: "15px",
                  borderRadius: "50%",
                  background: "#52c41a",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    background: "#fff",
                    display: "inline-block",
                  }}
                />
              </span>
              {t("Approved")}
            </span>
          </div>
        </StyledLeftPanel>
        <Col xs={24} sm={24} md={24} lg={14} xl={18}>
          <Row>
            <Col md={12} sm={24} xs={24}>
              <StyledTitle>
                <StyledPreviousIcon onClick={previousMonth} style={iconStyle} />
                {localizedMonthName} {year}
                <StyledNextIcon onClick={nextMonth} style={iconStyle} />
              </StyledTitle>
            </Col>
          </Row>
          <Spin spinning={displayLoader}>
            {/* <StyledAntCalendarFull
              value={momentDate(miniCalendarCurrentDate)}
              fullscreen={true}
              dateFullCellRender={dateFullCellRender}
            /> */}
            <CustomCalendar
              tabId={tabId}
              holidayList={holidayList}
              miniCalendarCurrentDate={miniCalendarCurrentDate}
              addLeave={addLeave}
              Menulist={Menulist}
              leaveList={
                tabId === t("Mine")
                  ? leaveList
                  : tabId === t("My Team")
                  ? myTeamLeaveList
                  : allLeaveList
              }
              wfhList={wfhList}
              timeoffList={timeoffList}
              overtimeList={overtimeList}
              setLeaveDetails={setLeaveDetails}
              getLeaveList={getLeaveList}
              toggleLeaveModal={toggleLeaveModal}
              handleEditIconClick={handleEditIconClick}
              getData={getData}
            />
          </Spin>
        </Col>
        <LeaveForm
          isModalVisible={displayLeaveModal}
          closeModal={(isReloadLeave) => {
            toggleLeaveModal(false);
            setEditLeaveDisable(false);
            if (isReloadLeave) getLeaveList();
          }}
          editLeaveDisable={editLeaveDisable}
          leaveDetails={leaveDetails}
        />
        <LeaveList
          isModalVisible={isLeaveListModalVisible}
          closeModal={() => toggleLeaveListModalVisible(false)}
          date={get(leaveListFiterForHR, "date", "")}
          status_id={get(leaveListFiterForHR, "status_id", "")}
          department_id={departmentSelectedByHR}
        />
      </Row>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  leaveCategoryList: getLeaveCategoryList(state),
  userList: getUserList(state),
  roleList: getRoleList(state),
});

export default connect(mapStateToProps, null)(Calendar);
